import {
	SET_FORM_STATE,
	GET_VISMON_LAST_UPDATE,
	GET_SITE_LIST,
	GET_PARAMETER_PLANNING_TABLE,
} from '../actions/ParameterPlanningActions';

const initialState = {
	formState: { siteId: '', antenna: 'AIR3227/78', lteBands: ['L800', 'L1800', 'L2100', 'L2600'] },
	vismonLastUpdate: '',
	siteList: [],
	parameterPlanningTableData: []
};

const parameterPlanningReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_VISMON_LAST_UPDATE: {
						return {
							...state,
							vismonLastUpdate: action.vismonLastUpdate
						};
					}
					case GET_SITE_LIST: {
						return {
							...state,
							siteList: action.siteList
						};
					}
					case GET_PARAMETER_PLANNING_TABLE: {
						return {
							...state,
							parameterPlanningTableData: action.parameterPlanningTableData
						};
					}
					default: {
						return state;
					}
	}
};

export default parameterPlanningReducer;
